// Imports
import firebase from '../config/FirebaseConfig'
import AxiosConfig from '../foreplayServer/serverAxiosConfig'

// Setup
const db = firebase.firestore()

// Get All By User - the team is resolved from the caller's token server side
const getAllCreatedByUser = async () => {
  const user = firebase.auth().currentUser

  if (!user) return []

  const token = await user.getIdToken()

  const { data: response } = await AxiosConfig.get('/fs/invitations/team', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  return response.data
}

const getUserInvitations = async () => {
  const user = firebase.auth().currentUser

  if (!user) return []

  const snapshot = await db.collection('invitations')
    .where('toEmail', '==', user.email.toLocaleLowerCase())
    .where('status', '==', 'pending')
    .get()

  return snapshot.docs?.map(doc => {
    return {
      id: doc.id,
      ...doc.data() || []
    }
  })
}

const remove = async (invitationId) => {
  const user = firebase.auth().currentUser
  if (!user) throw new Error('Not Authorized. Refresh the page and try again.')

  const token = await user.getIdToken()

  const { data: response } = await AxiosConfig.delete(`/fs/invitations/${invitationId}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  return response.data
}

const reject = async (invitationId) => {
  const user = firebase.auth().currentUser
  if (!user) throw new Error('Not Authorized. Refresh the page and try again.')

  const token = await user.getIdToken()

  const { data } = await AxiosConfig.post(`/team/invite/${invitationId}/respond`, {
    action: 'rejected'
  }, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  return data
}

const getInvitationById = async (invitationId) => {
  const user = firebase.auth().currentUser
  if (!user) throw new Error('Not Authorized. Refresh the page and try again.')

  const token = await user.getIdToken()

  const { data } = await AxiosConfig.get(`/fs/invitations/${invitationId}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
  return data
}

const ignoreAll = async (allInvitations) => {
  if (!Array.isArray(allInvitations) || allInvitations.length === 0) return []

  const validInvitations = allInvitations.filter(invitation => invitation?.id)
  if (validInvitations.length === 0) return []

  const user = firebase.auth().currentUser
  if (!user) throw new Error('Not Authorized. Refresh the page and try again.')

  const token = await user.getIdToken()

  return Promise.all(
    validInvitations.map(invitation => {
      return AxiosConfig.post(`/team/invite/${invitation.id}/respond`, {
        action: 'rejected'
      }, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
    })
  )
}

export default {
  getAllCreatedByUser,
  getUserInvitations,
  reject,
  remove,
  getInvitationById,
  ignoreAll
}
